

import { useCallback, useMemo } from 'react'
import { 
  useGetEmployeesQuery as getEmployeesQuery, 
  useGetEmployeeQuery as getEmployeeQuery, 
  useGetAbsencesQueryQuery as getAbsencesQuery } from '../../../api/plamo-api'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import { ActionTableState } from '../action-table/action-table'


function AbsenceTable({ as, preselectedEmployeeId, preselectedEmployeeClosureId, begin, end }: any) {

  
  const columns = useMemo(() => [
    {
      title: "Id",
      dataIndex: "id",
      sorter: true,
      filter: true,
      type: 'int',
    },
    ...(preselectedEmployeeId ? [] : [
      {
        title: "Mitarbeiter",
        dataIndex: "employeeId",
        type: 'reference',
        typeAttrs: {
          referenceList: () => getEmployeesQuery({ o: 0, c: 1000, st: JSON.stringify({ name: 'asc' }), f: JSON.stringify({}) }),
          referenceSingle: id => getEmployeeQuery({ id }),
          referenceDisplayString: employee => `${employee.id} - ${employee.firstName} ${employee.lastName}`,
          referenceLabel: employee => <Link to={`/employee/${employee.id}`}>{employee.id} - {employee.firstName} {employee.lastName}</Link>,
          referenceGetId: employee => employee.id
        },      
      },
    ]
    ),
    {
      title: "Beginn",
      dataIndex: "begin",
      render: v => dayjs(v).format('DD.MM.YYYY')
    },
    {
      title: "Ende",
      dataIndex: "end",
      render: v => dayjs(v).format('DD.MM.YYYY')
    },
    {
      title: "Arbeitstage",
      dataIndex: "workingDays",
    },
    {
      title: "Grund",
      dataIndex: "reason"
    },
  ], [preselectedEmployeeId])

  const applyPreselectedToFilter = useCallback(f => {
    const obj = JSON.parse(f);
    if(preselectedEmployeeClosureId) {
      obj["employeeClosureId"] ={
        c: "EQ",
        v: preselectedEmployeeClosureId
      }
    }
    if(preselectedEmployeeId) {
      obj["employeeId"] = {
        c: "EQ",
        v: preselectedEmployeeId
      }
    }
    if(begin && end) {
      obj["begin"] = {
        c: "BTW",
        v: dayjs(begin).utc().format('YYYY-MM-DDTHH:mm:ss') + '.000', 
        v2: dayjs(end).utc().format('YYYY-MM-DDTHH:mm:ss') + '.000', 
        t: 'DATE'
      }
    }
    return JSON.stringify(obj);
  }, [preselectedEmployeeId, preselectedEmployeeClosureId, begin, end])

  console.log("Absence table begin, end", begin, end)

  return (
    <>
    <div>
    <ActionTableState
          isParentLoading={false}
          tableData={{
            defaultSortKey: 'id',
            defaultSortDirection: 'desc',
            columns,
            dataSource: {
              pageableQueryEndpoint: ({ f, ...rest }) => getAbsencesQuery({ f: applyPreselectedToFilter(f), ...rest }),
              queryResultMapping: (result) => result?.items
            },
          }}
        />
    </div>
    </>
    
  )
}

export default AbsenceTable